// extracted by mini-css-extract-plugin
module.exports = {"faq":"_22I_V","list":"_2Ha-n"};